import { Component, EventEmitter, HostListener, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConductorService } from '../../services/conductor.service';
import { ConductorDTO } from '../../../dtos/conductor.dto';
import moment from "moment";
import { CommonModule, NgIf } from "@angular/common";
import { ApiService } from '../../services/api.service';
import { AppMessage } from '../../app.message';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EventService } from '../../services/event.service';
import { JornadaDTO } from "../../../dtos/jornada.dto";
import { PdfDTO } from "../../../dtos/pdf.dto";
import { MotivoCierreJornadaDTO } from '../../../dtos/motivoCierreJornada.dto';
import { GetListaMotivosCierreJornadaResponseDTO } from '../../../dtos/response/getListaMotivosCierreJornada.response.dto';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-modal-cierre-jornada',
  standalone: true,
    imports: [
        CommonModule,
        NgIf,
        FormsModule,
        NgSelectModule,
    ],
  templateUrl: './modal-cierre-jornada.component.html',
  styleUrl: './modal-cierre-jornada.component.scss'
})
export class ModalCierreJornadaComponent implements OnInit, OnDestroy {

  private conductor: ConductorDTO;
  horaActual: string = '';
  intervalHoraActual: any;
  public accion: string = 'PREVIO_CIERRE';
  public listaMotivosCierre: MotivoCierreJornadaDTO[];
  public motivoCierreSeleccionado : MotivoCierreJornadaDTO;
  public detalleCierre : string;
  public enviando: boolean = false;
  public procesandoPdf: boolean = false;

  constructor(
    private modalRef: BsModalRef,
    private conductorService: ConductorService,
    private apiService: ApiService,
    private eventService: EventService,
    private toastr: ToastrService,
    private userService: UserService,
  ) {

    this.eventService.subscribe('CONDUCTOR_ACTUALIZADO_MQTT_EVENT', (conductor: ConductorDTO) => {
      if(conductor.uuid == this.conductor.uuid) {
        this.conductor = conductor;
      }
    })
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.close();
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalHoraActual)
  }

  ngOnInit(): void {
    this.horaActual = moment().format("HH:mm:ss");
    this.conductor = this.conductorService.getConductorSeleccionado();
    this.intervalHoraActual = setInterval(() => { this.horaActual = moment().format("HH:mm:ss"); }, 1000);
    this.getlistaMotivosCierre();

  }

  getlistaMotivosCierre(){
    this.apiService.getListaMotivosCierreJornadaGestionDeConductores().subscribe({
      next: (response) => {
        this.getlistaMotivosCierreSuccess(response)
      },
      error: (error) => {
        this.getlistaMotivosCierreError(error)
      }
    });
  }

  getlistaMotivosCierreSuccess(getListaMotivosCierreJornada : GetListaMotivosCierreJornadaResponseDTO){
    this.listaMotivosCierre = getListaMotivosCierreJornada.data.list;
    if(this.listaMotivosCierre.length >= 1){
      this.motivoCierreSeleccionado = this.listaMotivosCierre[0];
    }
  }

  getlistaMotivosCierreError(error: HttpErrorResponse){
    console.log('error lista motivos', error);
    this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  get getTiempoEnEstadoHHmm(): string {
    const ahora = moment();
    const inicio = moment.utc(this.conductor.jornadaEnCurso.fechaHoraInicio).local();

    if (!inicio.isValid()) {
      return "--";
    }

    const diff = moment.duration(ahora.diff(inicio));
    const horas = Math.floor(diff.asHours());
    const minutos = diff.minutes();

    return `${this.pad(Math.abs(horas))}:${this.pad(Math.abs(minutos))}`;
  }

  pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

  finalizarJornadaEImprimir() {
    const imprimir = true;
    this.finalizarJornada(imprimir);
  }

  finalizarJornada(imprimir : boolean = false) {
    const now = moment.utc().seconds(0).milliseconds(0).toISOString().replace(/\.\d{3}Z$/, 'Z');

    const motivo = this.motivoCierreSeleccionado ? this.motivoCierreSeleccionado.motivo : 'desconocido';

    this.enviando = true;
    this.apiService.putFinalizarJornadaGestionConductores(
      this.conductor.uuid,
      'FUERA_JORNADA',
      this.conductor.jornadaEnCurso.uuid,
      'FINALIZADA',
      now,
      motivo,
      this.detalleCierre
    ).subscribe({
      next: (res) => this.finalizarJornadaSuccess(res, imprimir),
      error: (err) => this.finalizarJornadaError(err)
    });
  }

  finalizarJornadaSuccess(resp: any, imprimir : boolean) {
    this.eventService.publish('FINALIZAR_JORNADA_CONDUCTORES_EVENT');

    if(imprimir){
      this.apiService.getFinJornadaPDF(this.conductor.jornadaEnCurso.uuid).subscribe(
        (resp) => this.getFinJornadaPDFSuccess(resp),
        (error) => this.getFinJornadaPDFError(error)
      );
    }

    this.enviando = false;
    this.close();
  }

  finalizarJornadaError(error: HttpErrorResponse) {
    console.log('error lista viajes', error);
    this.enviando = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_FINALIZAR_JORNADA_CONDUCTORES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  muestraHora(fecha: string) {
    return moment(fecha, 'YYYY-MM-DDTHH:mm:ss').format('HH:mm');
  }

  get getHora() {
    return this.horaActual;
  }

  close() {
    this.modalRef.hide();
  }

  tienePermisoFinalizarJornada(): boolean {
    return this.userService.tienePermiso('CONDUCTOR_FINALIZAR');
  }

  tienePermisoImprimirJornada(): boolean {
    return this.userService.tienePermiso('VOUCHER_JORNADA');
  }

  get getConductor(): ConductorDTO {
    return this.conductor;
  }

  getFinJornadaPDF() {
    this.procesandoPdf = true;
    this.apiService.getFinJornadaPDF(this.conductor.jornadaEnCurso.uuid)
      .subscribe((resp) => this.getFinJornadaPDFSuccess(resp), (error) => this.getFinJornadaPDFError(error));
  }

  getFinJornadaPDFSuccess(pdfDTO: PdfDTO,) {
    this.procesandoPdf = false;
    console.log('exito pdf');
    pdfDTO.generatePdfFromBase64();
  }

  getFinJornadaPDFError(error: HttpErrorResponse) {
    this.procesandoPdf = false;
    console.log('error kpis', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

}
